<template>
    <div  class="all-height">
        <el-main class="all-height">
            <div class="operation-bar">
                <h1>已处理订单明细</h1>
                <div class="operation-bar-right">
                    <div class="input-box">
                        <i class="el-icon-search" @click="query"></i>
                        <input type="text" v-model="keyword" placeholder="采购行项目号、物料编码或名称"/>
                    </div>
                    <a href="javascript:void(0)" @click="exportExcel">导出Excel</a>
                    <a href="javascript:void(0)" @click="back">返回</a>
                </div>
            </div>

            <div class="table-box">
                <el-table :data="detailList" height="calc(100% - 55px)"
                          :header-cell-style="{background:'#4885CA', color: 'white'}">

                    <el-table-column type="index" width="50" label="序号" align="center" header-align="center" >
                    </el-table-column>
                    <el-table-column property="orderNo" width="120" label="订单编号" align="center" header-align="center"  :show-overflow-tooltip='true'>
                    </el-table-column>
                    <el-table-column label="采购行项目" width="110"  align="center" header-align="center"  :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <span type="text">{{scope.row.rowNo}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column property="sapSaleOrderNo" width="130" label="销售订单号" align="center" header-align="center"  :show-overflow-tooltip='true'>
                    </el-table-column>
                    <el-table-column label="销售行项目" width="110"  align="center" header-align="center"  :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <span>{{scope.row.sapSaleOrderRowNo === '0'?'':scope.row.sapSaleOrderRowNo}}</span>
                        </template>
                    </el-table-column>

                    <el-table-column label="物料编码" width="120" align="center" header-align="center"  :show-overflow-tooltip='true'>
                        <template slot-scope="scope">
                            <span>{{scope.row.sapMtrlCode.substr(-10,10)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column property="sapMtrlName" width="220" label="物料名称" align="center" header-align="center" :show-overflow-tooltip='true'>
                    </el-table-column>
                    <el-table-column property="sapMtrlDesc" width="220" label="物料描述" align="center" header-align="center" :show-overflow-tooltip='true'>
                    </el-table-column>
                    <el-table-column property="price" width="100"  label="价格" align="center" header-align="center"  :show-overflow-tooltip='true'>
                    </el-table-column>
                    <el-table-column property="sapPriceUnit" width="100"  label="价格单位" align="center" header-align="center"  :show-overflow-tooltip='true'>
                    </el-table-column>
                    <el-table-column property="sapTaxCodeDesc" width="100"  label="价格单位" align="center" header-align="center"
                                     :show-overflow-tooltip='true'>
                    </el-table-column>
                    <el-table-column property="uom" width="50" label="单位" align="center" header-align="center"  :show-overflow-tooltip='true'>
                    </el-table-column>
                    <el-table-column property="qty" width="90" label="数量" align="center" header-align="center"  :show-overflow-tooltip='true'>
                    </el-table-column>
                    <el-table-column property="expectDate" width="100" label="交货日期" align="center" header-align="center"  :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column property="vendorRemark" width="150" label="沟通备注" align="center"  :show-overflow-tooltip='true' header-align="center">
                    </el-table-column>
                    <el-table-column property="ownerRemark" width="150" label="采购方备注" align="center"  :show-overflow-tooltip='true' header-align="center">
                    </el-table-column>
                    <el-table-column width="80"  label="状态"  align="center" header-align="center"  :show-overflow-tooltip='true'>
                        <template slot-scope="scope">
                            <el-button type="text">
                                <el-tag type="warning">已处理</el-tag>
                            </el-button>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作"  align="center" header-align="center"  :show-overflow-tooltip='true'>
                        <template slot-scope="scope">
                            <el-button type="text">
                                <el-tag type="success" @click="downLoad(scope.row.sapMtrlCode.substr(-10,10))">下载</el-tag>
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="table-page">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="page.current"
                            :page-sizes="page.pageSizes"
                            :page-size="page.pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="page.total">
                    </el-pagination>
                </div>
            </div>
        </el-main>

    </div>

</template>

<script>
    export default {
        name: "finish-detail",
        props: ['orderId', 'isLock'],
        data() {
            return {
                detailList: [],
                page: {
                    current: 1,
                    pageSize: 15,
                    pageSizes: [15,30,50,100],
                    total: 0
                },
                keyword: '',
                labelWidth: '80px',
            }
        },
        methods: {
            //根据物料编码条用doc-server中的接口 下载相应的文件
            downLoad(no) {
                let param ={};
                param.no = no;
                // param.no = "20110033721";
              this.$store.dispatch('order/order/download', param)
            },
            handleSizeChange(val) {
                this.page.pageSize = val;
                this.loadDetailList();
            },

            handleCurrentChange(val) {
                this.page.current = val;
                this.loadDetailList();
            },

            loadDetailList() {
                this.$store.dispatch('order/order/getOrderDetailList', {
                    current: this.page.current,
                    size: this.page.pageSize,
                    orderId: this.orderId,
                    keyword: this.keyword
                }).then((res)=> {
                    this.detailList = res.records;
                    this.page.total = res.total;
                })
            },

            query() {
                this.page.current = 1;
                this.loadDetailList();
            },

            back() {
              this.$emit("closeDetail");
            },

            exportExcel() {
                if(!this.orderId){
                    return;
                }
                this.$store.dispatch('order/order/exportExcel', {orderId: this.orderId});
            }

        },
        created() {
            this.loadDetailList();
        }
    };
</script>

<style scoped>
    .table-box{
        position: relative;
        margin-top: 5px;
        background-color: white;
        height: calc(100% - 35px);
        width: 100%;
    }
    .table-page {
        width: 100%;
        text-align: center;
        position: absolute;
        bottom: 10px;
    }
    .el-table .el-button{
        padding: 0;
    }
    .cell i {
        font-size: 25px;
        cursor: pointer;
    }
    .cell i:hover {
        color: #5ED1FD;
    }
    .textArea-box {
        max-height: 300px;
        overflow-y: scroll;
    }
</style>
